import React from 'react'
import { Analytics, Auth } from 'aws-amplify'
import awsConfig from './aws'
import { AppProvider } from './stores/AppStore'
import { UserProvider } from './stores/UserStore'
import Router from './Router'
import { toast, Zoom } from 'react-toastify'
import './i18n'
import theme from './utils/theme'
import { ThemeProvider } from 'styled-components'

toast.configure({
  autoClose: 4000,
  draggable: false,
  transition: Zoom,
  hideProgressBar: true,
  closeButton: false
})


Auth.configure(awsConfig)
// alert(JSON.stringify(awsConfig))
Analytics.configure({ disabled: true })

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <UserProvider>
          <Router />
        </UserProvider>
      </AppProvider>
    </ThemeProvider>
  )
}

export default App
